'use strict';

/*global services*/
/*global createObjectCallBack*/

function K2LoginKeyboard(settings) {
  this.$loginForm = null;
  this.settings = null;

  this.init(settings);
}

K2LoginKeyboard.prototype = $.extend({}, {
  constructor: 'K2LoginKeyboard',

  registerCallbacks: function registerCallbacks() {
    var _this = this;

    var $alerts = _this.$loginForm.find('.alert');

    // login
    _this.$loginForm.find('input[name="_username"]').on('click', function () {
      var setting = {
        title: services.get('translator').trans('security.login.insert_username'),
        saveBtnTitle: services.get('translator').trans('security.login.insert'),
        submitCallBack: 'submitLoginKeyboardForm',
        enterSubmitCallBack: 'submitLoginKeyboardForm',
        value: $(this).val(),
        type: 'text',
        content: $('<div />').append($alerts.clone()).html(),
      };

      _this.openLoginKeyboardForm(setting);
      return false;
    });

    // password
    _this.$loginForm.find('input[name="_password"]').on('click', function () {
      var setting = {
        title: services.get('translator').trans('security.login.insert_password'),
        saveBtnTitle: services.get('translator').trans('security.login.login'),
        submitCallBack: 'submitPasswordKeyboardForm',
        enterSubmitCallBack: 'submitPasswordKeyboardForm',
        value: $(this).val(),
        type: 'password',
        content: '',
      };

      _this.openLoginKeyboardForm(setting);
      return false;
    });

    // button LoginKeyboard
    $('#username').closest('form').on('submit', function () {
      if ((_this.$loginForm.find('input[name="_username"]').val().length <= 0) || (_this.$loginForm.find('input[name="_password"]').val().length <= 0)) {
        $('#username').trigger('click');
        return false;
      }
    });
  },

  //----------------------------------------------------------------------------

  openLoginKeyboardForm: function openLoginKeyboardForm(setting) {
    var _this = this;

    var modal = services.get('modal-keyboard');
    modal.empty().open({
      title: setting.title,
      saveBtnTitle: setting.saveBtnTitle,
      height: 'auto',
      width: 'md',
      modalClass: 'login-keyboard-form',
      submitCallBack: createObjectCallBack(_this, setting.submitCallBack),
      enterSubmitCallBack: createObjectCallBack(_this, setting.enterSubmitCallBack),
      form: true,
      focusInput: false,
      keyboardClose: false,
      content: setting.content + '<div class="keyboard-wrapper"></div>'
    });

    _this.initLoginKeyboardForm(setting);

    return _this;
  },

  submitLoginKeyboardForm: function submitLoginKeyboardForm() {
    var _this = this;

    var modal = services.get('modal-keyboard');
    modal.close();

    setTimeout(function () {
      _this.$loginForm.find('input[name="_username"]').val(services.get('keyboard').getValue());
      _this.$loginForm.find('input[name="_password"]').trigger('click');
    }, 500);

    return _this;
  },

  submitPasswordKeyboardForm: function submitPasswordKeyboardForm() {
    var _this = this;

    var keyboard = services.get('keyboard');
    var modal = services.get('modal-keyboard');
    modal.close();

    _this.$loginForm.find('input[name="_password"]').val(keyboard.getValue());
    _this.$loginForm.submit();

    return _this;
  },

  initLoginKeyboardForm: function initLoginKeyboardForm(setting) {
    var _this = this;

    var keyboard = services.get('keyboard');
    var modal = services.get('modal-keyboard');

    modal.contentDOM().find('.keyboard-wrapper').append(keyboard.getKeyboard());
    keyboard.reset();
    keyboard.setPlaceholder(setting.title);
    keyboard.setLayout('numeric', true);
    keyboard.setVirtualFocus();
    keyboard.setInputType(setting.type);

    if (_this.settings.enabledSpace) {
      keyboard.enableSpaceBtn();
    }

    return _this;
  },

  //----------------------------------------------------------------------------

  init: function init(settings) {
    var _this = this;

    _this.settings = $.extend({}, {
      enabledSpace: false
    }, settings);

    _this.$loginForm = $('#login-form');

    _this.registerCallbacks();

    _this.$loginForm.find('input[name="_username"]').trigger('click');

    return _this;
  }
});
